import React from 'react';

import { useIsAdmin, useIsCustomer, useIsHr, useIsManager, useIsTabel } from '~modules/auth/model';
import { routerKeys } from '~shared/router';

export interface MenuItemType {
	title: string;
	ico?: string;
	link?: string;
	submenu?: MenuItemType[];
	open?: boolean;
	external?: boolean;
	onClick?: (event?: React.MouseEvent) => void;
	active?: () => boolean;
}

const useMenu = (): MenuItemType[] => {
	const isManager = useIsManager();
	const isHr = useIsHr();
	const isAdmin = useIsAdmin();
	const isCustomer = useIsCustomer();
	const isTabel = useIsTabel();

	const menu: MenuItemType[] = [];

	if (isManager) {
		menu.push({
			title: 'Регистрация на смену',
			link: routerKeys.manager.root(),
			onClick: () => {
				console.log('handle click');
			},
		});
	}

	if (isCustomer) {
		menu.push({
			title: 'Сессия',
			link: routerKeys.session(),
			onClick: () => {
				console.log('handle click');
			},
		});
		menu.push({
			title: 'Нарушения',
			link: routerKeys.cabinet.errors.root(),
		});
		menu.push({
			title: 'Пин-коды',
			link: routerKeys.pinCodes(),
		});
	}

	if (isAdmin) {
		menu.push({
			title: 'Администрирование',
			open: true,
			submenu: [
				{
					title: 'Участки',
					link: routerKeys.cabinet.admin.sections.root(),
				},
				{
					title: 'Пользователи',
					link: routerKeys.cabinet.admin.users.root(),
				},
				{
					title: 'Настройки',
					link: routerKeys.cabinet.admin.settings.root(),
				},
				{
					title: 'Справочники помещений',
					link: '/b/directories',
					external: true,
				},
			],
		});
	}

	if (isHr || isTabel) {
		const submenu: MenuItemType[] = [
			{
				title: 'Табель',
				link: routerKeys.tabel.root(),
			},
			{
				title: 'Отметки сотрудника',
				link: routerKeys.tabel.attendance(),
			},
		];
		if (isHr) {
			submenu.push(
				...[
					{
						title: 'Роль на участке',
						link: routerKeys.tabel.roles(),
					},
					{
						title: 'Период табелирования',
						link: routerKeys.tabel.period(),
					},
					{
						title: 'Таблица погрешностей',
						link: routerKeys.tabel.rounding(),
					},
					{
						title: 'Лимиты рабочих часов',
						link: routerKeys.tabel.limits(),
					},
				],
			);
		}
		menu.push({
			title: 'Табелирование',
			open: true,
			submenu,
		});
	}

	menu.push({
		title: 'Журналы АО',
		link: '/b/',
		external: true,
	});

	return menu;
};

export default useMenu;
